import React from "react"
import PropTypes from "prop-types"
import HourlyRoundsTimeline from "../HourlyRoundsTimeline"
import { secondsToHoursAndMinutes } from "../../helpers/sharedHelperFunctions"
import "./RoomStatusBsr.scss"
import Loading from "../Loading"
import moment from "moment"

export default class RoomStatusBsr extends React.PureComponent {
  roundsMet = rounds => {
    const roundsMet = rounds.reduce((opportunityCount, round) => {
      if (round.compliant) return opportunityCount + 1
      else return opportunityCount
    }, 0)
    return [roundsMet, rounds.length]
  }

  secondsToMinutesAndSeconds = timeInSeconds => {
    const minutes = Math.floor(timeInSeconds / 60)
    const seconds = timeInSeconds - minutes * 60
    return {
      minutes,
      seconds,
    }
  }

  render() {
    if (!this.props.loading) {
      const rounds = this.roundsMet(this.props.shiftAssignment.rounds)
      const beginningShiftChange = this.props.shiftAssignment
        .beginningShiftChange
      const endingShiftChange = this.props.shiftAssignment.endingShiftChange

      const checkMark = (
        <span className="compliant icon-styles" title="compliant" />
      )
      const xMark = (
        <span className="non-compliant icon-styles" title="non-compliant" />
      )

      const BSRDisplay = shiftChange => {
        const bsrCompliance = shiftChange && shiftChange.complianceMet
        // BsrDuration is a changeable value by our clients. Initially, it was always 180 seconds, so if there is not historical value (i.e. null), we use what it would have been, 180 seconds.
        const historicalDurationThreshold =
          shiftChange && shiftChange.currentBsrComplianceDurationSeconds
            ? shiftChange.currentBsrComplianceDurationSeconds
            : 180
        const startTime = shiftChange ? shiftChange.bsrStartsAt : ""
        const duration = shiftChange ? shiftChange.duration : 0
        const durationObj = this.secondsToMinutesAndSeconds(duration)

        const headerMessage = (
          <div className="panel-heading-grey">
            {duration > 0 &&
              (duration < historicalDurationThreshold ||
                !historicalDurationThreshold) &&
              !bsrCompliance && (
                <div className="text-extrasmall semi-bold text-gray">
                  Duration did not meet threshold of{" "}
                  {historicalDurationThreshold} seconds
                </div>
              )}
            {!shiftChange && (
              <div className="text-extrasmall semi-bold text-gray">
                N/A can occur for three reasons: double shifts, no patient
                occupancy, or data is still being calculated.
              </div>
            )}
            {shiftChange && !bsrCompliance && duration === 0 && (
              <div className="text-extrasmall semi-bold text-gray">
                No overlapping visits detected
              </div>
            )}
          </div>
        )
        const visualIndicator = (
          <span>{shiftChange ? (bsrCompliance ? checkMark : xMark) : ""}</span>
        )
        const startAndDuration = (
          <div className="panel-heading">
            {duration > 0 && startTime && (
              <>
                <span>
                  {moment.parseZone(startTime).format("hh:mma")}{" "}
                  {durationObj.minutes}m{durationObj.seconds}s
                </span>
                {visualIndicator}
              </>
            )}
          </div>
        )
        return (
          <div>
            {startAndDuration}
            {headerMessage}
          </div>
        )
      }

      return (
        <div className="RoomStatusBsr">
          <div className="top-content">
            <div className="center-text">
              <div className="left-content">
                <div className="stats">
                  <div className="labels">
                    <div className="panels">
                      <div className="panel-wrapper">
                        <p className="small panel-title">Longest Absence</p>
                        <div className="panel-heading">
                          {secondsToHoursAndMinutes(
                            this.props.shiftAssignment.longestGap
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="panels">
                      <div className="panel-wrapper">
                        <p className="small panel-title">Hourly Rounds Met</p>
                        <div className="panel-heading">{`${rounds[0]} of ${
                          rounds[1]
                        }`}</div>
                      </div>
                    </div>
                    <div className="panels">
                      <div className="panel-wrapper">
                        <p className="small panel-title">Start Shift BSR</p>
                        {BSRDisplay(beginningShiftChange)}
                      </div>
                    </div>
                    <div className="panels">
                      <div className="panel-wrapper">
                        <p className="small panel-title">End Shift BSR</p>
                        {BSRDisplay(endingShiftChange)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-content">
            <HourlyRoundsTimeline
              rounds={this.props.shiftAssignment.rounds}
              startsAt={this.props.shiftAssignment.startsAt}
              endsAt={this.props.shiftAssignment.endsAt}
              roundingPeriodMinutes={
                this.props.shiftAssignment.roundingPeriodMinutes
              }
            />
          </div>
        </div>
      )
    } else {
      return (
        <div className="RoomStatus loading-container">
          <Loading />
        </div>
      )
    }
  }
}

RoomStatusBsr.propTypes = {
  loading: PropTypes.bool.isRequired,
  shiftAssignment: PropTypes.shape({
    rounds: PropTypes.array,
    longestGap: PropTypes.number,
    startsAt: PropTypes.string.isRequired,
    endsAt: PropTypes.string.isRequired,
    beginningShiftChange: PropTypes.object,
    endingShiftChange: PropTypes.object,
    roundingPeriodMinutes: PropTypes.number,
    currentBsrComplianceDurationSeconds: PropTypes.number,
  }).isRequired,
}

RoomStatusBsr.defaultProps = {
  isOpen: false,
}
